module.exports = __webpack_public_path__ + "img/HtmlZip_Icon_60x60.b581d370.jpg";